import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, HostListener, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { secureStorage } from './shared/services/encryption/secureservice';
import { ClevertapService } from './shared/services/clevertap/clevertap.service';
import { ApiService } from './shared/services/apiService.service';
import { environment } from '../environments/environment';
import { Observable, fromEvent, map, merge, of } from 'rxjs';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'tata-cv-online';
  sub: Subscription = new Subscription();
  i: number = 0;
  ccavenue: any;
  count = 0;
  timeout: any;

  environment1 = environment.s3bucket.url;

  offlineEvent: Observable<Event>;
  onlineEvent: Observable<Event>;
  subscriptions: Subscription[] = [];
  vasData: any;
  chatbotRouteData: any;
  fromValue: any;
  localsubmitVAShrInfo: string;
  amcData: any;
  amcdat: boolean = false;
  lateapiresponse:any
  amcDataArray=[]
  finalhr: number;
  constructor(@Inject(PLATFORM_ID) private platformId: Object, private route: ActivatedRoute, public chatbotService:ApiService,
    private localStorage: secureStorage,
    private toastrService: ToastrService,
    public router: Router,
    private cleverService: ClevertapService
  ) {
    if (isPlatformBrowser(this.platformId)) {
      const userAgent = navigator.userAgent;
      if (/Mac|iphone|ipad|ipod/i.test(userAgent)) {
        return;
      }
      else {
        this.cleverService.webpush();
      }
    }
  }
  ngOnInit(): void {

    if (isPlatformBrowser(this.platformId)) {
      this.sub.add(this.route.queryParams.subscribe((params) => {
        if (params['dealer']) {
          localStorage.setItem("dealercd", params['dealer']);
        }

      }));
      document.addEventListener("languageToggle", (event: any) => {
        this.cleverService.onLanguageChange(event.detail.currentLanguage);
      }, { passive: true });

      this.handleAppConnectivityChanges();
      window['getVcForChatbot'] = this.getVcForChatbot.bind(this);
      window['navigationLeadBooking'] = this.navigationLeadBooking.bind(this);
      window['navigationAMCList'] = this.navigationAMCList.bind(this);
      window['makeMyOwn'] = this.makeMyOwn.bind(this);
      window['amcAplicationDataChatbot'] = this.amcAplicationDataChatbot.bind(this);
      window['amcChatbot'] = this.amcChatbot.bind(this);


      //  window['hrSubmut']().subscribe((ele) =>{
      //  });

    this.vasData = JSON.parse(localStorage.getItem("vasInfo"))
    }
  }
  getVcForChatbot(val: any) {
    let data={
      "vehicle_number":val
    }
    this.chatbotService.getVcForChatbot(data).subscribe(response => {
      this.chatbotRouteData = response.data
      this.localsubmitVAShrInfo =  JSON.parse(localStorage.getItem("submitVAShrInfo"))
      const vasRecommendation =this.localsubmitVAShrInfo['vas_recommendation'] || {};
      this.amcDataArray = Object.keys(vasRecommendation).map((key) => {
      return { ...vasRecommendation[key] };
         });
    }, error => {
    });
  }



  navigationLeadBooking() {
    let data = this.chatbotRouteData;
    let amcFmsPlan =
      this.localsubmitVAShrInfo['vas_recommendation']?.amc_fms_plan;

    let VASData = {
      AnnualKms: amcFmsPlan?.yearly_contract_km
        ? amcFmsPlan.yearly_contract_km / 12
        : amcFmsPlan?.yearly_contract_hours,
      Exshowroomprice: data?.price_range,
      LOB: data?.lob,
      NoOfyears:
        this.localsubmitVAShrInfo['vas_recommendation']?.amc_fms_plan?.[
          'contract years'
        ] / 12,
      SubLob: data?.sub_lob,
      VASBookingAmount:
        data?.sub_lob == 'scv-cargo' ||
        data?.sub_lob == 'pickups' ||
        data?.sub_lob == 'scvpass' ||
        data?.sub_lob == 'scpass'
          ? 1000
          : 2000,
      // VASPLAN: this.localsubmitVAShrInfo['vas_recommendation'].amc_fms_plan?.plan,
      // VASTotalAmount: this.localsubmitVAShrInfo['vas_recommendation'].amc_fms_plan?.price_per_year,
      VASPLAN: this.amcDataArray,
      VASTotalAmount: this.calculateTotalAmountperyear(this.amcDataArray),
      VCNUMBER: data?.vehicle_number,
      VasAvailable: 'YES',
      crmApplication: '',
      fuel_type: data?.fuel_type ? data?.fuel_type : '',
      isViaConfigurator: true,
      isViaOSPVas: true,
      openPage: 'booking',
      taggedVC: [],
      terrian: this.fromValue.terrain,
      vasApplication: this.amcData,
      recommended_quantity: this.fromValue.chassis
    };

    this.localStorage.setItem('VASData', JSON.stringify(VASData));

    let sublob =
      data?.sub_lob.replace(/\s/g, '-')?.toLowerCase() == 'icv-trucks'
        ? 'trucks'
        : data?.sub_lob.replace(/\s/g, '-')?.toLowerCase() == 'buses'
        ? 'buses-vans'
        : data?.sub_lob.replace(/\s/g, '-')?.toLowerCase();
    let model = data?.model
      .replace(/\s/g, '-')
      .replace(/\//g, '-')
      .replace(/\+/g, '-')
      .replace(/\./g, '-')
      ?.toLowerCase();
    this.router.navigate([
      '/lead-booking/' +
        sublob +
        '/' +
        data?.lob_seo +
        '/' +
        data?.ppl_seo +
        '/' +
        model +
        '/' +
        data?.id,
    ]);
  }

  amcAplicationDataChatbot() {
    let data = {
      lob: this.chatbotRouteData?.lob,
      display_application: this.fromValue.application,
    };

    this.chatbotService.amcAplicationDataChatbot(data).subscribe(
      (response) => {
        this.amcData = response.data.vasrecappl_data[0].actual_application;
        localStorage.setItem('amcData', JSON.stringify(this.amcData));
      },
      (error) => {
      }
    );
  }

  amcChatbot() {
    let lobValue: string;

    switch (this.chatbotRouteData?.lob) {
      case 'hcv-const':
      case 'hcv-cargo':
        case 'HCV Const':
          case 'HCV Cargo':
        lobValue = 'hcv';
        break;
      case 'bus':
        case 'BUSES':
          case 'Buses':
        lobValue = 'bus';
        break;
      case 'magic':
        lobValue = 'tata_magic';
        break;
      case 'winger':
        case 'SCPASS':
        lobValue = 'winger';
        break;
      case 'hcv':
        lobValue = 'hcv';
        break;
      case 'ilmcv':
        lobValue = 'ilmcv';
        break;
      case 'scv':
        case 'SCV CARGO':
        lobValue = 'scv';
        break;
      case 'ScPass':
        lobValue = 'winger';
        break;
      case 'SCVPass':
        lobValue = 'tata_magic';
        break;
      case 'SCV Cargo':
        lobValue = 'scv';
        break;
      case 'Pickups':
        case 'PICKUPS':
      case 'Yodha & Intra':
        lobValue = 'scv';
        break;
      case 'mcv-trucks':
      case 'icv':
      case 'mhcv':
        case 'MCV Trucks':
        case 'ICV Trucks':
          case 'LCV':
        lobValue = 'ilmcv';
        break;
      default:
        lobValue = this.chatbotRouteData?.lob;
        break;
    }

    const valueOfHr = this.fromValue.average_km
      ? (this.fromValue.average_km *12)
      : (this.fromValue.average_Hr *12);
    this.finalhr = this.calculateFinalHr(valueOfHr);

    let data = {
      output_type: 'all',
      application: this.amcData,
      terrain: this.fromValue?.terrain,
      vc_no: localStorage.getItem('vehicle_number'),
      amc_duration: this.fromValue.amc * 12,
      annual_kms: this.finalhr,
      lob_name: lobValue?.toLowerCase(),
      pl: this.chatbotRouteData.pl,
    };
    this.chatbotService.amcChatbot(data).subscribe(
      (response) => {
        if (response) {
          this.lateapiresponse = response;
        }
      },
      (error) => {
      }
    );
  }



  calculateFinalHr(valueOfHr: number): number {
    if (this.chatbotRouteData.lob_seo === 'hcv-cargo') {
      if (valueOfHr <= 60000) return 60000;
      if (valueOfHr <= 70000) return 70000;
      if (valueOfHr <= 80000) return 80000;
      if (valueOfHr <= 90000) return 90000;
      return 100000;
    } else if (this.chatbotRouteData.lob_seo === 'hcv-const') {
      if (valueOfHr <= 1000) return 1000;
      if (valueOfHr <= 1500) return 1500;
      if (valueOfHr <= 2000) return 2000;
      if (valueOfHr <= 2500) return 2500;
      if (valueOfHr <= 3000) return 3000;
      if (valueOfHr <= 3500) return 3500;
      if (valueOfHr <= 4000) return 4000;
      if (valueOfHr <= 4500) return 4500;
      return 5000;
    } else if (
      this.chatbotRouteData.lob_seo === 'mcv-trucks' &&
      ['SIGNA 1923.K.', 'SIGNA 1923.TK.'].includes(this.chatbotRouteData.pl)
    ) {
      if (valueOfHr <= 1000) return 1000;
      if (valueOfHr <= 1500) return 1500;
      if (valueOfHr <= 2000) return 2000;
      if (valueOfHr <= 2500) return 2500;
      if (valueOfHr <= 3000) return 3000;
      if (valueOfHr <= 3500) return 3500;
      if (valueOfHr <= 4000) return 4000;
      if (valueOfHr <= 4500) return 4500;
      return 5000;
    } else if (
      ['icv-trucks', 'lcv', 'mcv-trucks'].includes(this.chatbotRouteData.lob_seo)
    ) {
      if (valueOfHr <= 40000) return 40000;
      if (valueOfHr <= 50000) return 50000;
      if (valueOfHr <= 60000) return 60000;
      if (valueOfHr <= 70000) return 70000;
      if (valueOfHr <= 80000) return 80000;
      if (valueOfHr <= 90000) return 90000;
      return 100000;
    }

    return valueOfHr;
  }


  makeMyOwn() {
    if (this.lateapiresponse?.RESPONSE.TOTAL_COUNT == 0) {
      this.navigationLeadBooking();
    } else {
      let data = this.chatbotRouteData;

      let sublob =
        data?.sub_lob?.replace(/\s/g, '-')?.toLowerCase() == 'icv-trucks'
          ? 'trucks'
          : data?.sub_lob?.replace(/\s/g, '-')?.toLowerCase() == 'buses'
          ? 'buses-vans'
          : data?.sub_lob?.replace(/\s/g, '-')?.toLowerCase();
      let model = data?.model
        ?.replace(/\s/g, '-')
        ?.replace(/\//g, '-')
        ?.replace(/\+/g, '-')
        ?.replace(/\./g, '-')
        ?.toLowerCase();
      let application = this.amcData?.replace(/\//g, '-');
      let terrain = this.fromValue?.terrain?.replace(/\//g, '-');
      this.router
        .navigate([
          '/booking-amc-list/' +
            sublob +
            '/' +
            data?.lob_seo +
            '/' +
            data?.ppl_seo +
            '/' +
            model +
            '/' +
            data?.id +
            '/' +
            data?.vehicle_number +
            '/' +
            application +
            '/' +
            terrain +
            '/' +
            this.fromValue.amc * 12 +
            '/' +
            this.finalhr,
        ])
        .then((navigationSuccess) => {
          if (navigationSuccess) {
            localStorage.setItem('quantity', this.fromValue?.chassis)
          } else {
            console.error('Navigation failed.');
          }
        });
    }
  }

  navigationAMCList(values){
    this.fromValue = values
  }

  private handleAppConnectivityChanges(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.onlineEvent = fromEvent(window, 'online');
      this.offlineEvent = fromEvent(window, 'offline');

      this.subscriptions.push(this.onlineEvent.subscribe(e => {
        // handle online mode
        this.toastrService.success("Internet Connected!")

      }));

      this.subscriptions.push(this.offlineEvent.subscribe(e => {
        // handle offline mode
        this.toastrService.warning("Connection Interrupted! Please check your internet connection")

      }));
    }
  }

  @HostListener('window:mousemove')
  @HostListener('window:keypress')
  @HostListener('window:DOMMouseScroll')
  @HostListener('window:mousewheel')
  @HostListener('window:touchmove')
  @HostListener('window:MSPointerMove')
  @HostListener('window:keydown')
  @HostListener('window:mousedown')
  resetTimer() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.clevertap();
    }, 30000);
  }
  clevertap() {
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onIdleScreen();
      } catch { }
    }
  }

  calculateTotalAmountperyear(data:any) {
    return data.reduce((sum, service) => {
       return sum + (service.price_per_year);
     }, 0);
   }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem("dealercd");
      localStorage.removeItem("dealername");
      this.subscriptions.forEach(subscription => subscription.unsubscribe());


    }
  }
}




